import { isEmpty } from 'ramda';
import { isNotEmpty } from 'ramda-adjunct';
import { Product, WarehouseState } from '../../model';
import { HandlePosition, ProcessConfig } from './stateMachine';

export const formatAmount = (amount: string | number = 0): string => {
  return parseFloat(parseFloat(amount.toString()).toFixed(6)).toString();
};

/**
 * Adds a unique item to an array if it doesn't already exist and is not empty.
 * Optionally applies a transformation function to the item before adding.
 *
 * @param array - The source array
 * @param newItem - The item to add
 * @param transform - Optional transformation function (e.g., trim, toLowerCase)
 * @returns New array with the item added if unique and not empty, otherwise original array
 */
export const addUniqueItemToArray = <T>(array: T[], newItem: T, transform?: (item: T) => T): T[] => {
  const processedItem = transform ? transform(newItem) : newItem;
  if (isNotEmpty(processedItem) && !array.includes(processedItem)) {
    return [...array, processedItem];
  }
  return array;
};

export function productHasDetailInfo(product: Product, warehouseState: WarehouseState, processConfig: ProcessConfig) {
  return (
    (product.description && product.description.length > 1) ||
    (product.imageSource && product.imageSource.length > 1) ||
    (warehouseState.position && !isEmpty(warehouseState.position)) ||
    processConfig.handlePosition !== HandlePosition.NEVER
  );
}
